export default {"src":"/_next/static/media/oaf.08e10576.svg","height":70,"width":194,"blurWidth":0,"blurHeight":0};